var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLivePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "10px",
    viewBox: "0 0 15 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-live-preview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09-Select-landing-page-template",
    transform: "translate(-344.000000, -1295.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(329.000000, 1282.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(15.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-live-preview",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.5,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 0.5,
    cy: 5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.5,
    cy: 5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9015,4.704 C14.9015,4.704 12,0 7.5,0 C3,0 0.0985,4.704 0.0985,4.704 L0.0814999225,5.272 C0.081,5.272 2.5,10 7.5,10 C12.5,10 14.919,5.272 14.919,5.272 L14.9015,4.704 Z M7.5,8.5 C5.567,8.5 4,6.933 4,5 C4,3.067 5.567,1.5 7.5,1.5 C9.433,1.5 11,3.067 11,5 C11,6.933 9.433,8.5 7.5,8.5 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLivePreview);
export default __webpack_public_path__ + "static/media/icon-live-preview.a0db23bef924902164225be422b3cb95.svg";
export { ForwardRef as ReactComponent };